import {
  SET_PENDING,
  SET_TOUCHED,
  SET_BATTERY_PICKUPS,
  FORGET_BATTERY_PICKUPS,
} from "./types";

const INITIAL_STATE = {
  all: [],
  open: [],
  closed: [],
  ref: {},
  pending: true,
  touched: false,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_PENDING:
      return { ...state, pending: payload };
    case SET_TOUCHED:
      return { ...state, touched: payload };
    case SET_BATTERY_PICKUPS:
      return { ...state, ...payload };
    case FORGET_BATTERY_PICKUPS:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};
